var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_887_7494)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_887_7494",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 0H0V35H35V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_887_7494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1938 13.125H21.8751V5.83311C21.8751 5.03125 21.2188 4.375 20.417 4.375H14.5839C13.782 4.375 13.1258 5.03125 13.1258 5.83311V13.125H10.807C9.50889 13.125 8.85264 14.7 9.77139 15.6187L16.4651 22.3125C17.0339 22.8813 17.9526 22.8813 18.5214 22.3125L25.2151 15.6187C26.1339 14.7 25.492 13.125 24.1945 13.125H24.1938ZM7.29199 27.7081C7.29199 28.51 7.94824 29.1662 8.7501 29.1662H26.2501C27.052 29.1662 27.7082 28.51 27.7082 27.7081C27.7082 26.9062 27.052 26.25 26.2501 26.25H8.7501C7.94824 26.25 7.29199 26.9062 7.29199 27.7081Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_887_7494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.2c0a66272fe5dfcb343e6128ab9e546b.svg";
export { ForwardRef as ReactComponent };